export class SugarMoneyProgramRpcError extends Error {
  message: string;
  txid: string;

  constructor({ txid, message }) {
    super();
    this.message = message;
    this.txid = txid;
  }
}

export class PermissionError extends Error {
  constructor() {
    super('call not authorized');
  }
}

export class SlippageError extends Error {
  constructor() {
    super('slippage cannot be more than 100%');
  }
}

export class TradeError extends Error {
  constructor(msg: string) {
    super(msg);
  }
}
